
export const linzParcelArea = {"id": 232, "area": 292947352.349952};

export const linzParcelMostIntensiveSustainableLandUse = {
    "response": {
        "area": 2.9294735234994453E8, "layers": [{
            "name": "lri_phys_sustain",
            "raster": false,
            "rows": [{
                "columns": [{"name": "Class", "value": "2"}, {
                    "name": "Class Description",
                    "value": "Intensive grazing"
                }, {"name": "Class Color", "value": "#CEE151"}, {
                    "name": "Class Area",
                    "value": 4.319581088569704E7
                }, {"name": "Class Abbreviation", "value": "IGrz"}, {
                    "name": "Class Flags",
                    "value": 3
                }, {
                    "name": "Class Flags Hash",
                    "value": {
                        "SHOW_LONG_NAME_IN_CONTENTS": false,
                        "HIDE_FROM_CONTENTS_PAGE": false,
                        "VISUALISATION": true,
                        "QUERY_ABLE": true
                    }
                }], "number": 1
            }, {
                "columns": [{"name": "Class", "value": "3"}, {
                    "name": "Class Description",
                    "value": "Extensive grazing"
                }, {"name": "Class Color", "value": "#94C23D"}, {
                    "name": "Class Area",
                    "value": 1.2464917441263996E8
                }, {"name": "Class Abbreviation", "value": "EGrz"}, {
                    "name": "Class Flags",
                    "value": 3
                }, {
                    "name": "Class Flags Hash",
                    "value": {
                        "SHOW_LONG_NAME_IN_CONTENTS": false,
                        "HIDE_FROM_CONTENTS_PAGE": false,
                        "VISUALISATION": true,
                        "QUERY_ABLE": true
                    }
                }], "number": 2
            }, {
                "columns": [{"name": "Class", "value": "4"}, {
                    "name": "Class Description",
                    "value": "Forestry"
                }, {"name": "Class Color", "value": "#335F1B"}, {
                    "name": "Class Area",
                    "value": 4.956252592822241E7
                }, {"name": "Class Abbreviation", "value": "For"}, {
                    "name": "Class Flags",
                    "value": 3
                }, {
                    "name": "Class Flags Hash",
                    "value": {
                        "SHOW_LONG_NAME_IN_CONTENTS": false,
                        "HIDE_FROM_CONTENTS_PAGE": false,
                        "VISUALISATION": true,
                        "QUERY_ABLE": true
                    }
                }], "number": 3
            }, {
                "columns": [{"name": "Class", "value": "5"}, {
                    "name": "Class Description",
                    "value": "Pasture with trees"
                }, {"name": "Class Color", "value": "#839331"}, {
                    "name": "Class Area",
                    "value": 6283493.598505486
                }, {"name": "Class Abbreviation", "value": "Past"}, {
                    "name": "Class Flags",
                    "value": 3
                }, {
                    "name": "Class Flags Hash",
                    "value": {
                        "SHOW_LONG_NAME_IN_CONTENTS": false,
                        "HIDE_FROM_CONTENTS_PAGE": false,
                        "VISUALISATION": true,
                        "QUERY_ABLE": true
                    }
                }], "number": 4
            }, {
                "columns": [{"name": "Class", "value": "6"}, {
                    "name": "Class Description",
                    "value": "Protection"
                }, {"name": "Class Color", "value": "#A5A5D7"}, {
                    "name": "Class Area",
                    "value": 6.770823018592761E7
                }, {"name": "Class Abbreviation", "value": "Prot"}, {
                    "name": "Class Flags",
                    "value": 3
                }, {
                    "name": "Class Flags Hash",
                    "value": {
                        "SHOW_LONG_NAME_IN_CONTENTS": false,
                        "HIDE_FROM_CONTENTS_PAGE": false,
                        "VISUALISATION": true,
                        "QUERY_ABLE": true
                    }
                }], "number": 5
            }]
        }], "pointHeight": 0
    }
}